import { createSlice } from "@reduxjs/toolkit";
import { STAUTES } from "../../../../utils/constant";
import { AUTH_LOGIN, IDENTITY_LOGIN_V2 } from "../../../../utils/services/apiPath";
import { postApi, refreshToken } from "../../../../utils/services";
import { expiredSessionHelper, loginHelper, logoutHelper } from "../../../../utils/helper";
import { encryptText } from "../../../../utils/crypto";
import { REMOVE_PERMISSION } from "../permissions/permissionsSlice";
import posthog from "posthog-js";

const initialState = {
  isAuthenticated: false,
  isMounted: false,
  user: null,
  userRole: null,
  status: STAUTES.IDLE
};

export const handleIdentityLogin = (payload, callback) => {
  return async dispatch => {
    dispatch(SET_STATUS(STAUTES.LOADING));
    try {
      const data = await postApi(IDENTITY_LOGIN_V2, { ...payload });
      loginHelper(data);
      dispatch(LOGIN({ user: data.user, role: data.user.roleTypeGuid }));
      dispatch(SET_STATUS(STAUTES.IDLE));
    } catch (error) {
      console.log(error);
      callback(error.message);
      dispatch(SET_STATUS(STAUTES.ERROR));
    }
  };
};

export const handleLogin = (payload, callback) => {
  return async dispatch => {
    dispatch(SET_STATUS(STAUTES.LOADING));
    try {
      const { error, data } = await postApi(AUTH_LOGIN, { ...payload, portalType: 2, password: encryptText(payload.password) });
      if (error) callback(error);
      else {
        loginHelper(data);
        dispatch(LOGIN({ user: data.user, role: data.user.roleTypeGuid }));
      }
      dispatch(SET_STATUS(STAUTES.IDLE));
    } catch (error) {
      console.log(error);
      callback(error.message);
      dispatch(SET_STATUS(STAUTES.ERROR));
    }
  };
};

export const handleLogout = () => {
  return async dispatch => {
    dispatch(SET_STATUS(STAUTES.LOADING));
    try {
      logoutHelper();
      dispatch(LOGOUT());
      dispatch(REMOVE_PERMISSION());
      dispatch(SET_STATUS(STAUTES.IDLE));
    } catch (error) {
      dispatch(SET_STATUS(STAUTES.ERROR));
    }
  };
};

export const handleInitialize = () => {
  return async dispatch => {
    try {
      if (await refreshToken()) {
        const user = JSON.parse(localStorage.getItem("user"));
        if (user) {
          dispatch(LOGIN({ user, role: user.roleTypeGuid }));
        }
        dispatch(SET_MOUNTED());
      } else {
        expiredSessionHelper();
      }
    } catch (error) {
      console.log(error);
      dispatch(SET_MOUNTED());
    }
  };
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    LOGIN: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      const { companyName } = action.payload.user;
      posthog.identify(companyName);
      state.userRole = action.payload.user.roleTypeGuid;
    },
    LOGOUT: state => {
      localStorage.removeItem("standardReports");
      localStorage.removeItem("customReports");
      state.isAuthenticated = false;
      state.user = null;
      state.userRole = null;
    },
    SET_STATUS: (state, action) => {
      state.status = action.payload;
    },
    SET_MOUNTED: state => {
      state.isMounted = true;
    }
  }
});

export const { LOGIN, LOGOUT, SET_STATUS, SET_MOUNTED } = authSlice.actions;

export const loginSelector = state => state.auth;
export const userSelector = state => state.auth.user;
export const userRoleSelector = state => state.auth.userRole;

export default authSlice.reducer;
